(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8238],{

/***/ 13787:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telemedicine/categories",
      function () {
        return __webpack_require__(61286);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22522);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31591);
/* harmony import */ var _styles_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64952);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78287);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  visibility: ",
        ";\n  position: ",
        ";\n  display: flex;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin: 0 2px;\n  }\n  p:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 24px 0;\n  position: relative;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var CustomBreadCrumbs = function(param) {
    var visible = param.visible, breadCrumbs = param.breadCrumbs;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var onClickBreadCrumb = function(name) {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .logger */ .kg)({
            pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .getPageName */ .j0)(router),
            eventName: "breadcrumb_".concat(name, "_click")
        });
    };
    var breadCrumbsWithHome = [
        {
            label: "홈",
            url: "/",
            logName: "home"
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(breadCrumbs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        visible: visible,
        id: "breadcrumbs",
        children: breadCrumbsWithHome.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Path, {
                role: "button",
                onClick: function() {
                    return onClickBreadCrumb(item.logName);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: item.label
                            })
                        })
                    }),
                    index !== breadCrumbsWithHome.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            }, item.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomBreadCrumbs);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aed661fe-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "static" : "absolute";
}, _styles_layout__WEBPACK_IMPORTED_MODULE_10__/* .Tablet */ .YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
});
var Path = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aed661fe-1"
})(_templateObject1());
var BreadCrumbsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aed661fe-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__/* .zIndex.BreadCrumb */ .W.BreadCrumb);
CustomBreadCrumbs.Wrapper = BreadCrumbsWrapper;


/***/ }),

/***/ 22522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var BreadCrumbArrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.557 2.67311C5.43361 2.69613 5.32045 2.77137 5.25001 2.87723C5.20047 2.95168 5.17989 3.01695 5.17636 3.11082C5.17199 3.22681 5.19204 3.30295 5.25091 3.39399C5.26614 3.41752 5.75502 3.90878 7.5576 5.71185L9.84498 7.99985L7.5576 10.2879C5.75502 12.0909 5.26614 12.5822 5.25091 12.6057C5.19204 12.6968 5.17199 12.7729 5.17636 12.8889C5.17896 12.9579 5.18893 13.0034 5.21347 13.0579C5.26381 13.1698 5.37402 13.27 5.49032 13.3095C5.59721 13.3459 5.73841 13.3389 5.83633 13.2924C5.92155 13.2519 5.7554 13.4152 8.27956 10.891C9.62615 9.54438 10.6303 8.537 10.6468 8.51612C10.8436 8.26702 10.882 7.92846 10.7457 7.64359C10.7179 7.58549 10.6842 7.53099 10.6468 7.48359C10.6303 7.46271 9.62615 6.45533 8.27956 5.10871C6.23381 3.06291 5.93645 2.76711 5.90463 2.74629C5.82035 2.69112 5.75534 2.67081 5.65514 2.66833C5.61039 2.66722 5.58087 2.66866 5.557 2.67311Z",
            fill: "#A9AEB1"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbArrow);


/***/ }),

/***/ 75275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31591);
/* harmony import */ var _types_app__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9912);
/* harmony import */ var _types_header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37072);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  & > * {\n    &:first-child {\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: ",
        ";\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: column;\n  width: 100%;\n  top: 0;\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          top: ",
        "px;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          top: 0px;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: column;\n  width: 100%;\n  z-index: ",
        ";\n  position: sticky;\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  z-index: ",
        ";\n  position: sticky;\n  bottom: 0;\n  padding: 32px 20px 20px;\n  background-color: ",
        ";\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 1) 30%,\n    rgba(255, 255, 255, 1) 100%\n  );\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-3b0b8d64-0"
})(_templateObject());
var TemplateHeader = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-3b0b8d64-1"
})(_templateObject1(), function(param) {
    var position = param.position;
    return position ? position : "sticky";
}, function(param) {
    var theme = param.theme, useSafeArea = param.useSafeArea;
    return "\n      background-color: ".concat(theme.color.white, ";\n      border: 0px solid ").concat(useSafeArea ? "red" : "green", ";\n  ");
}, function(param) {
    var theme = param.theme, useSafeArea = param.useSafeArea, height = param.height;
    var _client = theme.client, clientType = _client.clientType, isAndroid = _client.isAndroid;
    var headerHeight = height !== null && height !== void 0 ? height : 60;
    switch(clientType){
        case _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.MOBILE_WEBVIEW */ .B.MOBILE_WEBVIEW:
            if (isAndroid) {
                return "\n            height: ".concat(headerHeight, "px;\n          ");
            }
            return "\n          height: ".concat(useSafeArea ? headerHeight : 100, "px;\n        ");
        case _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.WEB */ .B.WEB:
            return "\n          height: ".concat(headerHeight, "px;\n        ");
        case _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.MOBILE_WEB */ .B.MOBILE_WEB:
            return "\n          height: ".concat(headerHeight, "px;\n          top: 60px;\n        ");
        default:
            return "\n            height: ".concat(0, "px;\n          ");
    }
});
var StickyTemplateHeader = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-3b0b8d64-2"
})(_templateObject4(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__/* .zIndex.AppHeader */ .W.AppHeader, function(param) {
    var type = param.type, theme = param.theme;
    switch(type){
        case _types_header__WEBPACK_IMPORTED_MODULE_4__/* .HeaderType.WithMobileHeader */ .n.WithMobileHeader:
            {
                return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), [
                    _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.WEB */ .B.WEB,
                    _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.MOBILE_WEBVIEW */ .B.MOBILE_WEBVIEW
                ].includes(theme.client.clientType) ? 0 : 60);
            }
        default:
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject3());
    }
});
var Content = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-3b0b8d64-3"
})(_templateObject5());
var StickyBottom = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-3b0b8d64-4"
})(_templateObject6(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__/* .zIndex.BottomSticky */ .W.BottomSticky, function(param) {
    var theme = param.theme;
    return theme.color.white;
});
// eslint-disable-next-line @typescript-eslint/no-empty-function
var TemplateLayout = function() {};
var Header = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TemplateHeader, {
        useSafeArea: props.useSafeArea,
        position: props.position,
        height: props.height,
        children: props.children
    });
};
var StickyHeader = function(param) {
    var children = param.children, type = param.type, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyTemplateHeader, {
        type: type,
        style: style,
        children: children
    });
};
TemplateLayout.Wrapper = Wrapper;
/**
 * @deprecated 확장성을 위해 이관예정
 */ TemplateLayout.Header = Header;
TemplateLayout.StickyHeader = StickyHeader;
TemplateLayout.Content = Content;
TemplateLayout.StickyBottom = StickyBottom;
/* harmony default export */ __webpack_exports__["Z"] = (TemplateLayout);


/***/ }),

/***/ 27265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qd": function() { return /* binding */ AccordionItem; },
/* harmony export */   "UQ": function() { return /* binding */ Accordion; },
/* harmony export */   "o4": function() { return /* binding */ AccordionTrigger; },
/* harmony export */   "vF": function() { return /* binding */ AccordionContent; }
/* harmony export */ });
/* unused harmony export useAccordionContext */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61536);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13029);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _utils_style__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76666);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10929);










var AccordionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var useAccordionContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AccordionContext);
    if (context === undefined) {
        throw new Error("useAccordionContext must be used within an AccordionProvider");
    }
    return context;
};
var AccordionProvider = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), initialMount = ref[0], setInitialMount = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setInitialMount(undefined);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccordionContext.Provider, {
        value: {
            initialMount: initialMount
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
            children: children
        }))
    });
};
var Accordion = AccordionProvider;
var accordionVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_6__/* .cva */ .j)("typography-ui-17sb flex w-full items-center justify-between transition-all [&[data-state=open]>svg]:rotate-180", {
    variants: {
        variant: {
            default: "px-[12px] ",
            lg: "px-[24px]"
        },
        size: {
            default: "h-[56px]",
            sm: "h-[48px]",
            lg: "h-[64px]"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
var AccordionItem = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, _hasBorderBottom = _param.hasBorderBottom, hasBorderBottom = _hasBorderBottom === void 0 ? true : _hasBorderBottom, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "hasBorderBottom"
    ]);
    var initialMount = useAccordionContext().initialMount;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Item */ .ck, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_utils_style__WEBPACK_IMPORTED_MODULE_7__.cn)("border-gray-50 border-t-0 border-r-0 border-b-[1px] border-l-0 border-solid", className, {
            "data-[state=closed]:[&>div]:hidden": initialMount !== undefined,
            "border-b-0": !hasBorderBottom
        })
    }, props));
});
AccordionItem.displayName = "AccordionItem";
var AccordionTrigger = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _size = _param.size, size = _size === void 0 ? "default" : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "children",
        "variant",
        "size"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Header */ .h4, {
        asChild: true,
        className: "flex items-center justify-between",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Trigger */ .xz, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            ref: ref,
            className: (0,_utils_style__WEBPACK_IMPORTED_MODULE_7__.cn)(accordionVariants({
                variant: variant,
                size: size
            }), className)
        }, props), {
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: "h-4 w-4 shrink-0 transition-transform duration-200"
                })
            ]
        }))
    });
});
AccordionTrigger.displayName = _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Trigger.displayName */ .xz.displayName;
var AccordionContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    var initialMount = useAccordionContext().initialMount;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Content */ .VY, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        forceMount: initialMount,
        className: "overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,_utils_style__WEBPACK_IMPORTED_MODULE_7__.cn)("", className),
            children: children
        })
    }));
});
AccordionContent.displayName = _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Content.displayName */ .VY.displayName;



/***/ }),

/***/ 76122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lE": function() { return /* binding */ useGetDiagnosisCategoriesV2Query; },
/* harmony export */   "ze": function() { return /* binding */ useSearchDoctorsByUserQuery; }
/* harmony export */ });
/* unused harmony exports SearchDoctorsByUserDocument, GetDiagnosisCategoriesV2Document */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var SearchDoctorsByUserDocument = "\n    query SearchDoctorsByUser($request: DoctorSearchByUserRequestInput!) {\n  searchDoctorsByUser(request: $request) {\n    totalCount\n    items {\n      createdAt\n      hospitalName\n      id\n      publicId\n      isAffiliated\n      medicineType\n      name\n      profileUrl\n      medicineType\n      professionalDepartment {\n        name\n      }\n      readyForVideoCall\n      reviewAverageRating\n      reviewCount\n      bookingInfo {\n        bookingAvailability\n        isBookable\n        todayBookable\n        todayCutoffTime\n        todayKickoffTime\n        todaySchedule\n        tomorrowBookable\n        tomorrowCutoffTime\n        tomorrowKickoffTime\n        tomorrowSchedule\n      }\n    }\n  }\n}\n    ";
var useSearchDoctorsByUserQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchDoctorsByUser",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByUserDocument, "SearchDoctorsByUser", variables), options);
};
useSearchDoctorsByUserQuery.getKey = function(variables) {
    return [
        "SearchDoctorsByUser",
        variables
    ];
};
useSearchDoctorsByUserQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByUserDocument, "SearchDoctorsByUser", variables, options);
};
var GetDiagnosisCategoriesV2Document = "\n    query GetDiagnosisCategoriesV2($contactType: DiagnosisContactType!) {\n  getDiagnosisCategoriesV2(contactType: $contactType) {\n    popularDepartmentCategories {\n      id\n      name\n    }\n    departmentCategories {\n      id\n      name\n      iconUrl\n      description\n    }\n    popularTreatmentCategories {\n      id\n      name\n    }\n    treatmentCategories {\n      id\n      name\n      iconUrl\n      items {\n        id\n        name\n      }\n    }\n  }\n}\n    ";
var useGetDiagnosisCategoriesV2Query = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetDiagnosisCategoriesV2",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDiagnosisCategoriesV2Document, "GetDiagnosisCategoriesV2", variables), options);
};
useGetDiagnosisCategoriesV2Query.getKey = function(variables) {
    return [
        "GetDiagnosisCategoriesV2",
        variables
    ];
};
useGetDiagnosisCategoriesV2Query.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDiagnosisCategoriesV2Document, "GetDiagnosisCategoriesV2", variables, options);
};


/***/ }),

/***/ 60643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ telemedicine_useGetDiagnosisCategories; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/telemedicine/telemedicine.gql.impl.tsx
var telemedicine_gql_impl = __webpack_require__(76122);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
;// CONCATENATED MODULE: ./src/models/diagnosis/category.ts


var DepartmentCategoryModel = /*#__PURE__*/ function() {
    "use strict";
    function DepartmentCategoryModel(id, name, description, icon) {
        (0,_class_call_check/* default */.Z)(this, DepartmentCategoryModel);
        this.id = id;
        this.name = name;
        this.description = description;
        this.icon = icon;
    }
    var _proto = DepartmentCategoryModel.prototype;
    _proto.getSeoTitle = function getSeoTitle() {
        switch(this.id){
            case "2":
                return "소아과(소아청소년과) 비대면 진료 | 아이 감기\xb7열\xb7기침 진료 - 닥터나우";
            default:
                return "".concat(this.name, " 비대면 진료 | 진료과\xb7질환별 원격진료 - 닥터나우");
        }
    };
    _proto.getSeoDescription = function getSeoDescription() {
        switch(this.id){
            case "2":
                return "아이가 아플 때 빠르게 소아과 진료를 받고 싶다면? 닥터나우에서 의사와 실시간 비대면진료 후 비대면 약 처방받아 보세요.";
            default:
                return "".concat(this.name, "에 맞는 의사를 빠르게 찾고, 병원 방문 없이 비대면진료로 약 처방까지 받아보세요.");
        }
    };
    _proto.getKeywords = function getKeywords() {
        switch(this.id){
            case "2":
                return "소아청소년과, 소아과 비대면 진료, 아기 감기, 기침, 열, 소아과약, 처방";
            default:
                return "비대면진료, 원격진료, 온라인진료, 비대면처방, 약처방, 약배송, 약배달, 진료비";
        }
    };
    return DepartmentCategoryModel;
}();
var PopularDepartmentCategoryModel = function PopularDepartmentCategoryModel(id, name) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, PopularDepartmentCategoryModel);
    this.id = id;
    this.name = name;
};
var PopularTreatmentCategoryModel = function PopularTreatmentCategoryModel(id, name) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, PopularTreatmentCategoryModel);
    this.id = id;
    this.name = name;
};
var TreatmentCategoryModel = /*#__PURE__*/ function() {
    "use strict";
    function TreatmentCategoryModel(id, name, icon, _treatments) {
        (0,_class_call_check/* default */.Z)(this, TreatmentCategoryModel);
        this.id = id;
        this.name = name;
        this.icon = icon;
        this._treatments = _treatments;
    }
    var _proto = TreatmentCategoryModel.prototype;
    _proto.getSeoTitle = function getSeoTitle(treatmentId) {
        switch(treatmentId){
            case "1":
                return "감기\xb7독감 비대면 진료 | 병원 방문 없이 처방받는 닥터나우";
            case "558":
                return "인공눈물 처방 | 안구건조증 비대면 진료 - 닥터나우";
            case "9":
                return "탈모약 비대면 진료 | 피나스테리드\xb7두타스테리드 처방 - 닥터나우";
            case "11":
                return "여드름약 비대면 진료 | 항생제\xb7외용제 빠른 처방 - 닥터나우";
            default:
                return "".concat(this.name, " 비대면 진료 | 진료과\xb7질환별 원격진료 - 닥터나우");
        }
    };
    _proto.getSeoDescription = function getSeoDescription(treatmentId) {
        switch(treatmentId){
            case "1":
                return "코감기, 인후통, 몸살 증상이 있으신가요? 병원 갈 필요 없이 닥터나우에서 의사와 비대면 진료 후 약 처방받아 보세요.";
            case "558":
                return "눈이 뻑뻑하고 피로하다면? 안과 갈 필요 없이 닥터나우에서 인공눈물, 안구건조증 치료제를 비대면 진료로 빠르게 처방받아보세요.";
            case "9":
                return "피나스테리드, 두타스테리드 등 탈모약을 병원 방문 없이 닥터나우에서 비대면으로 안전하게 처방받으세요.";
            case "11":
                return "여드름으로 고생하고 있다면? 피부과 방문 없이 닥터나우에서 항생제 및 외용제를 비대면 진료로 처방받아보세요.";
            default:
                return "".concat(this.name, "에 맞는 의사를 빠르게 찾고, 병원 방문 없이 비대면진료로 약 처방까지 받아보세요.");
        }
    };
    _proto.getKeywords = function getKeywords(treatmentId) {
        switch(treatmentId){
            case "1":
                return "감기, 독감, 인후통, 해열제, 비대면 처방";
            case "558":
                return "인공눈물, 안구건조증, 눈 피로, 비대면 진료, 안과 처방, 눈 시림, 눈물약";
            case "9":
                return "탈모약, 피나스테리드, 두타스테리드, 탈모 비대면 처방";
            case "11":
                return "여드름약, 여드름 처방, 피부과 비대면 진료, 항생제";
            default:
                return "비대면진료, 원격진료, 온라인진료, 비대면처방, 약처방, 약배송, 약배달, 진료비";
        }
    };
    (0,_create_class/* default */.Z)(TreatmentCategoryModel, [
        {
            key: "treatments",
            get: function get() {
                var _this = this;
                return this._treatments.map(function(treatment) {
                    return {
                        id: treatment.id,
                        name: treatment.name,
                        getSeoTitle: function() {
                            return _this.getSeoTitle(treatment.id);
                        },
                        getSeoDescription: function() {
                            return _this.getSeoDescription(treatment.id);
                        },
                        getKeywords: function() {
                            return _this.getKeywords(treatment.id);
                        }
                    };
                });
            }
        }
    ]);
    return TreatmentCategoryModel;
}();
var DiagnosisCategoryInfoModel = /*#__PURE__*/ function() {
    "use strict";
    function DiagnosisCategoryInfoModel(popularDepartmentCategories, popularTreatmentCategories, departmentCategories, treatmentCategories) {
        (0,_class_call_check/* default */.Z)(this, DiagnosisCategoryInfoModel);
        this.popularDepartmentCategories = popularDepartmentCategories;
        this.popularTreatmentCategories = popularTreatmentCategories;
        this.departmentCategories = departmentCategories;
        this.treatmentCategories = treatmentCategories;
    }
    var _proto = DiagnosisCategoryInfoModel.prototype;
    _proto.findDepartmentCategoryByCategoryId = function findDepartmentCategoryByCategoryId(categoryId) {
        return this.departmentCategories.find(function(category) {
            return category.id === categoryId;
        }) || null;
    };
    _proto.findTreatmentCategoryByTreatmentId = function findTreatmentCategoryByTreatmentId(treatmentId) {
        return this.treatmentCategories.find(function(category) {
            return category.treatments.some(function(treatment) {
                return treatment.id === treatmentId;
            });
        }) || null;
    };
    _proto.findTreatmentByTreatmentId = function findTreatmentByTreatmentId(treatmentId) {
        var foundCategory = this.findTreatmentCategoryByTreatmentId(treatmentId);
        if (!foundCategory) {
            return null;
        }
        return foundCategory.treatments.find(function(treatment) {
            return treatment.id === treatmentId;
        }) || null;
    };
    _proto.getDepartmentCategories = function getDepartmentCategories() {
        return this.departmentCategories;
    };
    return DiagnosisCategoryInfoModel;
}();

// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/hooks/telemedicine/useGetDiagnosisCategories.ts





var parseDiagnosisCategories = function(data) {
    var categoriesInfo = data.getDiagnosisCategoriesV2;
    return new DiagnosisCategoryInfoModel(categoriesInfo.popularDepartmentCategories.map(function(departmentCategory) {
        return new PopularDepartmentCategoryModel(departmentCategory.id, departmentCategory.name);
    }), categoriesInfo.popularTreatmentCategories.map(function(treatmentCategory) {
        return new PopularTreatmentCategoryModel(treatmentCategory.id, treatmentCategory.name);
    }), categoriesInfo.departmentCategories.map(function(departmentCategory) {
        var _description;
        return new DepartmentCategoryModel(departmentCategory.id, departmentCategory.name, (_description = departmentCategory.description) !== null && _description !== void 0 ? _description : "", departmentCategory.iconUrl);
    }), categoriesInfo.treatmentCategories.map(function(treatmentCategory) {
        return new TreatmentCategoryModel(treatmentCategory.id, treatmentCategory.name, treatmentCategory.iconUrl, treatmentCategory.items.map(function(treatment) {
            return {
                id: treatment.id,
                name: treatment.name
            };
        }));
    }));
};
var useGetDiagnosisCategories = function() {
    var ref = (0,telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query */.lE)({
        contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
    }, {
        select: parseDiagnosisCategories
    }), tmp = ref.data, categoriesInfo = tmp === void 0 ? new DiagnosisCategoryInfoModel([], [], [], []) : tmp;
    return {
        categoriesInfo: categoriesInfo
    };
};
/* harmony default export */ var telemedicine_useGetDiagnosisCategories = (useGetDiagnosisCategories);
useGetDiagnosisCategories.getKey = function() {
    return telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query.getKey */.lE.getKey({
        contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
    });
};
useGetDiagnosisCategories.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(useGetDiagnosisCategories.getKey(), telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query.fetcher */.lE.fetcher({
                            contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 61286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ categories; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/dnDesignSystem/components/ui/accordion.tsx
var accordion = __webpack_require__(27265);
// EXTERNAL MODULE: ./src/services/doctor/DiagnosisCategoryService.ts
var DiagnosisCategoryService = __webpack_require__(33310);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/templates/telemedicine/category/components/TreatmentCategoriesInfo.tsx






var TreatmentCategoriesInfo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "border-gray-50 border-t-0 border-r-0 border-b border-solid px-[24px] pt-[40px] pb-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "typography-ui-17sb text-gray-600",
                        children: "많이 찾는 증상"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mt-[20px] flex flex-wrap items-center gap-[8px]",
                        children: props.popularTreatmentCategories.map(function(category) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: common/* ROUTES.TELEMEDICINE.DOCTORS.path */.Z6.TELEMEDICINE.DOCTORS.path + (0,url/* addQueryString */.sC)({
                                        type: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
                                        id: category.id
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "flex h-[36px] items-center rounded-[40px] bg-gray-30 px-[16px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "typography-ui-15m text-gray-700",
                                            children: category.name
                                        })
                                    })
                                })
                            }, "popular-treatment-category-".concat(category.id));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion/* Accordion */.UQ, {
                    type: "multiple",
                    children: props.treatmentCategories.map(function(treatmentCategory) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion/* AccordionItem */.Qd, {
                            value: treatmentCategory.id,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion/* AccordionTrigger */.o4, {
                                    variant: "lg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-[12px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: treatmentCategory.icon,
                                                alt: treatmentCategory.name,
                                                className: "aspect-square h-[32px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "typography-ui-17sb text-gray-600",
                                                children: treatmentCategory.name
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion/* AccordionContent */.vF, {
                                    children: treatmentCategory.treatments.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-wrap items-center gap-[8px] px-[24px] py-[20px]",
                                        children: treatmentCategory.treatments.map(function(treatment) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: common/* ROUTES.TELEMEDICINE.DOCTORS.path */.Z6.TELEMEDICINE.DOCTORS.path + (0,url/* addQueryString */.sC)({
                                                        type: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
                                                        id: treatment.id
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "flex h-[36px] items-center rounded-[40px] bg-gray-30 px-[16px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "typography-ui-15m text-gray-700",
                                                            children: treatment.name
                                                        })
                                                    })
                                                })
                                            }, "popular-treatment-category-".concat(treatment.id));
                                        })
                                    })
                                })
                            ]
                        }, "treatment-category-".concat(treatmentCategory.id));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_TreatmentCategoriesInfo = (TreatmentCategoriesInfo);

// EXTERNAL MODULE: ./src/components/atom/CustomBreadCrumbs.tsx
var CustomBreadCrumbs = __webpack_require__(12429);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
;// CONCATENATED MODULE: ./src/components/templates/telemedicine/category/components/DepartmentCategoriesInfo.tsx





var DepartmentCategoriesInfo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "border-gray-50 border-t-0 border-r-0 border-b border-solid px-[24px] pt-[40px] pb-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "typography-ui-17sb text-gray-600",
                        children: "많이 찾는 과목"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mt-[20px] flex flex-wrap items-center gap-[8px]",
                        children: props.popularDepartmentCategories.map(function(category) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: common/* ROUTES.TELEMEDICINE.DOCTORS.path */.Z6.TELEMEDICINE.DOCTORS.path + (0,url/* addQueryString */.sC)({
                                        type: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
                                        id: category.id
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "flex h-[36px] items-center rounded-[40px] bg-gray-30 px-[16px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "typography-ui-15m text-gray-700",
                                            children: category.name
                                        })
                                    })
                                })
                            }, "popular-treatment-category-".concat(category.id));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flex flex-col",
                    children: props.departmentCategories.map(function(departmentCategory) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "border-gray-50 border-b-[1px] border-solid",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: common/* ROUTES.TELEMEDICINE.DOCTORS.path */.Z6.TELEMEDICINE.DOCTORS.path + (0,url/* addQueryString */.sC)({
                                    type: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
                                    id: departmentCategory.id
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "flex items-center justify-between p-[24px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "typography-ui-17sb mb-[4px] text-gray-700",
                                                    children: departmentCategory.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "typography-ui-15r text-gray-400",
                                                    children: departmentCategory.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: departmentCategory.icon,
                                            alt: departmentCategory.name,
                                            className: "aspect-square w-[40px]"
                                        })
                                    ]
                                })
                            })
                        }, "treatment-category-".concat(departmentCategory.id));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_DepartmentCategoriesInfo = (DepartmentCategoriesInfo);

// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/components/templates/telemedicine/category/TelemedicineCategoriesTemplate.tsx











var renderSelectedCategoryType = function(selectedCategoryType, categoriesInfo) {
    if (selectedCategoryType === DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TreatmentCategoriesInfo, {
            popularTreatmentCategories: categoriesInfo.popularTreatmentCategories,
            treatmentCategories: categoriesInfo.treatmentCategories
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DepartmentCategoriesInfo, {
        departmentCategories: categoriesInfo.departmentCategories,
        popularDepartmentCategories: categoriesInfo.popularDepartmentCategories
    });
};
var TelemedicineCategoriesTemplate = function(props) {
    var client = props.client, viewModel = props.viewModel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            !client.isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default */.Z, {
                    breadCrumbs: viewModel.breadCrumbs,
                    visible: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "typography-ui-22sb flex h-[60px] items-center pr-[20px] pl-[24px] text-gray-900",
                        children: "증상/과목 선택"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex h-[44px] w-full items-center border-gray-50 border-b-[1px] border-solid px-[16px]",
                        children: viewModel.tabs.map(function(tab) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (0,style.cn)([
                                    "relative flex h-full flex-1 items-center",
                                    {
                                        'before:absolute before:bottom-0 before:left-[8px] before:h-[2px] before:w-[calc(100%-16px)] before:bg-gray-800 before:opacity-0 before:transition-opacity before:duration-300 before:content-[""]': true,
                                        "before:opacity-100": viewModel.selectedCategoryType === tab.type
                                    }, 
                                ]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path + (0,url/* addQueryString */.sC)({
                                        type: tab.type
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (0,style.cn)([
                                            "flex h-full w-full items-center justify-center",
                                            {
                                                "typography-ui-15sb text-gray-800": viewModel.selectedCategoryType === tab.type,
                                                "typography-ui-15m text-gray-400": viewModel.selectedCategoryType !== tab.type
                                            }, 
                                        ]),
                                        children: tab.label
                                    })
                                })
                            }, tab.label);
                        })
                    }),
                    renderSelectedCategoryType(viewModel.selectedCategoryType, viewModel.categoriesInfo)
                ]
            })
        ]
    });
};
/* harmony default export */ var category_TelemedicineCategoriesTemplate = (TelemedicineCategoriesTemplate);

// EXTERNAL MODULE: ./src/hooks/telemedicine/useGetDiagnosisCategories.ts + 1 modules
var useGetDiagnosisCategories = __webpack_require__(60643);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/hooks/telemedicine/useTelemedicineCategoriesViewModel.ts




var tabs = [
    {
        type: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
        label: "증상"
    },
    {
        type: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
        label: "과목"
    }, 
];
var useTelemedicineCategoriesViewModel = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var selectedCategoryType = ((ref = router.query) === null || ref === void 0 ? void 0 : ref.type) || DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment;
    var categoriesInfo = (0,useGetDiagnosisCategories/* default */.Z)().categoriesInfo;
    var breadCrumbs = [
        {
            url: common/* ROUTES.TELEMEDICINE.DOCTORS.path */.Z6.TELEMEDICINE.DOCTORS.path,
            label: "비대면 진료",
            logName: "telemedicine_doctors"
        },
        {
            url: common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path,
            label: "증상/과목 선택",
            logName: "telemedicine_categories"
        }, 
    ];
    return {
        selectedCategoryType: selectedCategoryType,
        tabs: tabs,
        categoriesInfo: categoriesInfo,
        breadCrumbs: breadCrumbs
    };
};
/* harmony default export */ var telemedicine_useTelemedicineCategoriesViewModel = (useTelemedicineCategoriesViewModel);

// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
;// CONCATENATED MODULE: ./src/pages/telemedicine/categories.tsx
// PageDescription: 비대면진료 증상과목 카테고리 페이지






var TelemedicineCategoriesPage = function(param) {
    var client = param.client;
    var viewModel = telemedicine_useTelemedicineCategoriesViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "비대면 진료 가능한 의사 전체 보기 | 진료과\xb7질환별 원격진료 - 닥터나우",
                description: "내 증상에 맞는 의사를 빠르게 찾고, 병원 방문 없이 비대면 진료로 약 처방까지 받아보세요. 감기, 여드름, 탈모, 다이어트, 소아과, 인공눈물 등 다양한 진료과별 전문의가 실시간 대기 중입니다.",
                openGraph: {
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path).concat((0,url/* addQueryString */.sC)({
                        type: viewModel.selectedCategoryType
                    }))
                },
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: "비대면 진료, 원격진료, 진료과 전체 보기, 온라인 진료, 감기, 탈모, 여드름, 소아과, 인공눈물"
                    }, 
                ],
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path).concat((0,url/* addQueryString */.sC)({
                    type: viewModel.selectedCategoryType
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(category_TelemedicineCategoriesTemplate, {
                client: client,
                viewModel: viewModel
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var categories = (TelemedicineCategoriesPage);


/***/ }),

/***/ 37072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ HeaderType; }
/* harmony export */ });
var HeaderType;
(function(HeaderType) {
    HeaderType["WithMobileHeader"] = "withMobileHeader";
})(HeaderType || (HeaderType = {}));


/***/ }),

/***/ 76666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40489);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98388);


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,209,9774,2888,179], function() { return __webpack_exec__(13787); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);